import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { COLOR_BLACK } from '../../constants/colors';
import { breakpoints } from '../../constants/mediaqueries';
import { bulletStyles, fontStyles } from '../../constants/styles';
import { FUNNEL_SOURCE_BOOK_DIRECT } from '../../constants/analytics';
import { customMarkdown } from '../../helpers/markdown';

import LocalisedLink from '../LocalisedLink';
import Rate from '../Rate';


const Panel = styled.div`
  margin-bottom: 2rem;
  ${fontStyles.bodySmall}
`;

/* Names the room the rates below belong to. On the two-column desktop grid the
   panel spans the full row, so without this a right-hand card's rates read as
   if they belonged to the row rather than the card. Same section-heading scale
   as SuggestedRoomsHeading on the room template. */
const PanelHeading = styled.h2`
  ${fontStyles.subtitle}
  margin-bottom: 1rem;
`;

const Details = styled.div`
  margin-bottom: 1.5em;
  ${fontStyles.bodySmall}

  ul li {
    ${bulletStyles}
  }

  @media ${breakpoints.l} {
    width: 50%;
  }
`;

const RatesWrapper = styled.div`
  border-top: 1px solid ${COLOR_BLACK};
  border-bottom: 1px solid ${COLOR_BLACK};
`;

const SearchResult = styled.div`
  padding: .75em 0;

  & + & {
    border-top: 1px solid ${COLOR_BLACK};
  }
`;

const FullRoomLink = styled.p`
  margin-top: 1.5em;
`;


const RoomPanel = ({
  buttonColor, details, name, onChooseStay, roomPath, roomType, stays,
}) => {
  const sortedStays = Object.values(stays).sort((a, b) => a.total - b.total);

  return (
    <Panel>
      <PanelHeading>{name}</PanelHeading>
      <If condition={details}>
        <Details>{customMarkdown(details)}</Details>
      </If>
      <RatesWrapper>
        <For each="stay" of={sortedStays}>
          <SearchResult key={stay.ratePlan}>
            <Rate color={buttonColor} handleChooseStay={onChooseStay} roomType={roomType} source={FUNNEL_SOURCE_BOOK_DIRECT} stay={stay} />
          </SearchResult>
        </For>
      </RatesWrapper>
      <FullRoomLink>
        <LocalisedLink to={roomPath}>
          <FormattedMessage defaultMessage="Full room details" id="bookDirect.fullRoomDetails" />
        </LocalisedLink>
      </FullRoomLink>
    </Panel>
  );
};

RoomPanel.propTypes = {
  buttonColor: PropTypes.string.isRequired,
  details: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChooseStay: PropTypes.func.isRequired,
  roomPath: PropTypes.string.isRequired,
  roomType: PropTypes.string.isRequired,
  stays: PropTypes.object.isRequired,
};

export default RoomPanel;
